import { hrefFactoryForLegacyModules } from '../backstage-content';
import { PERMISSIONS_OPERATORS, BACKSTAGE_CONTENT_PERMISSION } from '../taboola-common-frontend-modules/authentication';

const MODULE_NAME = 'campaign-review';
const externalPath = 'reports/campaigns/campaign-approvals';

const hrefGetter = hrefFactoryForLegacyModules(MODULE_NAME, externalPath);
const permissions = {
    permissions: ['CAMPAIGN_ADMIN_EDIT', BACKSTAGE_CONTENT_PERMISSION],
    operator: PERMISSIONS_OPERATORS.AND,
};

export { MODULE_NAME, hrefGetter, permissions, externalPath };
